import React from 'react'
import { Modal, Table, Row, Col } from 'antd'
import NumberFormat from 'react-number-format'
import moment from 'moment'

const Money = ({ value }) => (
    <NumberFormat
        decimalScale={2}
        fixedDecimalScale
        thousandSeparator
        prefix="$"
        displayType="text"
        value={value || 0}
    />
)

const columns = [
    {
        title: 'Código',
        key: 'code',
        render: (label, item) => (item.product && item.product.barcode) || '',
    },
    {
        title: 'SKU',
        key: 'sku',
        render: (label, item) => (item.product && item.product.sku) || '',
    },
    {
        title: 'Artículo',
        key: 'name',
        render: (label, item) => (item.product && item.product.name) || '',
    },
    {
        title: 'Cantidad',
        dataIndex: 'quantity',
        key: 'quantity',
    },
    {
        title: 'Descuentos',
        key: 'discount_amount',
        render: (label, item) => <Money value={item.discount_amount} />,
    },
    {
        title: 'Total',
        key: 'total',
        render: (label, item) => <Money value={item.total} />,
    },
]

const InvoiceDetailModal = ({ visible, invoice, onClose }) => {
    if (!invoice) {
        return null
    }

    const customerLabel = invoice.customer
        ? `${invoice.customer.social_reason || '-SIN RAZÓN SOCIAL-'} (${invoice.customer.rfc || 'SIN RFC'})`
        : '---'

    return (
        <Modal
            title={`Factura - Orden #${invoice.unique_id}`}
            visible={visible}
            onCancel={onClose}
            onOk={onClose}
            cancelButtonProps={{ style: { display: 'none' } }}
            okText="Cerrar"
            width={800}
        >
            <Row gutter={16} style={{ marginBottom: 16 }}>
                <Col span={12}>
                    <strong>Fecha:</strong>{' '}
                    {invoice.created_at
                        ? moment(invoice.created_at).utcOffset(-360).format('DD/MM/YYYY HH:mm')
                        : '---'}
                </Col>
                <Col span={12}>
                    <strong>Sucursal:</strong> {invoice.subsidiary ? invoice.subsidiary.name : '---'}
                </Col>
                <Col span={12}>
                    <strong>Cliente:</strong> {customerLabel}
                </Col>
                <Col span={12}>
                    <strong>Folio fiscal (UUID):</strong> {invoice.invoice_uuid || '---'}
                </Col>
            </Row>

            <Table
                dataSource={invoice.items || []}
                columns={columns}
                rowKey="id"
                pagination={false}
                size="small"
            />

            <Row style={{ marginTop: 16, textAlign: 'right' }}>
                <Col span={24}>
                    <strong>Subtotal: </strong>
                    <Money value={invoice.sub_total} />
                    &nbsp;&nbsp;
                    <strong>Impuestos: </strong>
                    <Money value={invoice.tax_amount} />
                    &nbsp;&nbsp;
                    <strong>Total: </strong>
                    <Money value={invoice.grand_total} />
                </Col>
            </Row>
        </Modal>
    )
}

export default InvoiceDetailModal
